import { instantFromIso, toJst } from "@nijiurachan/js/util/time";

const WEEKDAYS = ["月", "火", "水", "木", "金", "土", "日"] as const;

function twoDigits(value: number): string {
  return String(value).padStart(2, "0");
}

function formatDateWithPrecision(
  dateStr: string,
  includeSeconds: boolean,
): string {
  const instant = instantFromIso(dateStr);
  if (!instant) return "";
  const date = toJst(instant);
  const weekday = WEEKDAYS[date.dayOfWeek - 1];
  const toMinute = `${twoDigits(date.year % 100)}/${twoDigits(date.month)}/${twoDigits(date.day)}(${weekday})${twoDigits(date.hour)}:${twoDigits(date.minute)}`;
  return includeSeconds ? `${toMinute}:${twoDigits(date.second)}` : toMinute;
}

export function formatDate(dateStr: string): string {
  return formatDateWithPrecision(dateStr, true);
}

/** ISO日時をJSTの「YY/MM/DD(曜)HH:mm」形式で表示する。 */
export function formatDateToMinute(dateStr: string): string {
  return formatDateWithPrecision(dateStr, false);
}
